import React from "react";
import styles from './ChatCalling.module.sass';

const ChatCalling = ({ roomInstance, callback, isCaller, peer }) => {

    return (
        <div className={styles.container}>
            { isCaller && <h2>You are calling this user</h2>}
            { !isCaller && <h2>This user is calling you.</h2>}
                            

            <div className={styles.btnContainer}>
                
                {isCaller ? (
                    <button className="button" onClick={ () => { peer.answerCall(false); callback?.()  }}>Cancel</button>
                ) : (
                <>
                    <button className="button" onClick={ () => { console.log('Accepting'); peer.answerCall(true); callback?.()  }}>Accept</button>
                    <button className="button" onClick={ () => { console.log('Rejecting'); peer.answerCall(false); callback?.()  }}>Reject</button>
                </>
                )}

            </div>
        </div>
);

};

export default ChatCalling;